import {on} from '@ngrx/store';
import * as CampaignActions from './campaign.actions';
import {Campaign} from 'gamesis-story-client';
import {createRehydrateReducer} from '../rehydrate.reducer';

export interface CampaignState {
    campaigns: Campaign[];
    campaign: string | undefined;
    loading: boolean;
    error: any;
}

const initialState: CampaignState = {
    campaigns: [],
    campaign: undefined,
    loading: false,
    error: null,
};

const _campaignReducer = createRehydrateReducer(
    'campaigns',
    initialState,
    on(CampaignActions.loadCampaigns,
        CampaignActions.createCampaign,
        CampaignActions.deleteCampaign,
        state => ({...state, loading: true})),
    on(CampaignActions.loadCampaignsSuccess,
        CampaignActions.createCampaignSuccess,
        CampaignActions.deleteCampaignSuccess,
        state => ({...state, error: null, loading: false})),
    on(CampaignActions.loadCampaignsSuccess, (state, {campaigns}) => ({...state, campaigns})),
    on(CampaignActions.campaignsFailure, (state, {error}) => ({...state, loading: false, error})),
    on(CampaignActions.setCampaign, (state, {id}) => ({...state, campaign: id})),
    on(CampaignActions.exitCampaign, (state) => ({...state, campaign: undefined}))
);

export function campaignReducer(state, action) {
    return _campaignReducer(state, action);
}
